import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const LogoElement = styled.p `
  font-family: 'TuesdayNight';
  color: #fff;
  width: 100%;
  text-align: center;
  font-size: 42px;
`;
export function Logo() {
    return _jsx(LogoElement, { children: "Dark side Mafia" });
}
